import '@/styles/app.scss';
import Vue, { CreateElement } from 'vue';
import VueRouter from 'vue-router';
import { createApp, defineComponent } from '@vue/composition-api';
// import type { CreateElement, VNode } from 'vue';
import '@/plugins/compositionApi';
import '@berlin-front/common/key-codes';
// import useAtoneOldBridge from '@services/service-type-bridge/AtoneOldBridge';
import useAtoneBridge from '@services/service-type-bridge/AtoneBridge';
import useAtoneLiteBridge from '@services/service-type-bridge/AtoneLiteBridge';
import useNPAtobaraiBridge from '@services/service-type-bridge/NPAtobaraiBridge';
import useAtoneAuthBridge from '@services/service-type-bridge/AtoneAuthBridge';
import useAtoneLiteAuthBridge from '@services/service-type-bridge/AtoneLiteAuthBridge';
import { services } from '@services/service-type-bridge';
import VueGtag from 'vue-gtag';
// import VueGtm from '@gtm-support/vue2-gtm';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import App from '@/App.vue';
import connectClient from '@berlin-front/common/connectClient';
import useProvideOrigin from '@berlin-front/common/composables/useProvideOrigin';
import '@berlin-front/common/i18n';

Vue.config.productionTip = false;
Vue.use(VueRouter);

// if (process.env.VUE_APP_GTM_CONTAINER_ID) {
//   Vue.use(VueGtm, {
//     id: process.env.VUE_APP_GTM_CONTAINER_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//     // queryParams: {
//     //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//     //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr', // cspell:disable-line
//     //   gtm_preview: 'env-4',
//     //   gtm_cookies_win: 'x',
//     // },
//     // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//     // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//     // nonce: '2726c7f26c', // Will add `nonce` to the script tag
//     enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//     debug: true, // Whether or not display console logs debugs (optional)
//     // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//     vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//     // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
//     // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
//   });
// }

if (process.env.VUE_APP_GTM_CONTAINER_ID) {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GTM_CONTAINER_ID,
      },
      disableScriptLoad: true,
    },
    router,
  );
}

services.push(
  // 定義したサービスタイプはここで追加する。
  // useAtoneOldBridge,
  useAtoneBridge,
  useAtoneLiteBridge,
  useNPAtobaraiBridge,
  useAtoneAuthBridge,
  useAtoneLiteAuthBridge,
);

// クライアントとのコネクションを開き、originを取得する。
// これは同期的に実行する必要があるためmain.tsのベタに書いてる。
// おそらくsetupブロックに書くと同期的に実行されない。
const origin = connectClient();

const app = createApp(
  defineComponent({
    name: 'Root',
    router,
    vuetify,
    // TODO: 型定義腐ってるのは公式。vue2.7で良くなるかどうか検証したい。
    render: (h: CreateElement) => h(App as unknown as undefined),
    setup() {
      // useOriginできるようにprovideする。
      useProvideOrigin(origin);
      return {};
    },
  }),
);

app.mount('#app');
